import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BuyerSidebar from '../../components/registraction/BuyerSidebar';
import BuyerStep1Business from '../../components/registraction/BuyerStep1Business';
import BuyerStep2Contact from '../../components/registraction/BuyerStep2Contact';
import BuyerStep3Address from '../../components/registraction/BuyerStep3Address';
import BuyerStep4Agreement from '../../components/registraction/BuyerStep4Agreement';
import BuyerStep5Review from '../../components/registraction/BuyerStep5Review';
import MobileStepper from '../../components/registraction/MobileStepper';
import { signup, clearSignupError } from '../../ducks/auth.duck';
import css from './FactoryRegistraction.module.css';

const BuyerRegistration = ({ className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const { signupInProgress, signupError } = useSelector(state => state.auth);

  const nextStep = values => {
    if (values) setFormData(prev => ({ ...prev, ...values }));
    setCurrentStep(prev => prev + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevStep = () => {
    dispatch(clearSignupError());
    setCurrentStep(prev => prev - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToStep = step => {
    dispatch(clearSignupError());
    setCurrentStep(step);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = values => {
    const allData = { ...formData, ...values };
    const nameParts = (allData.contactPersonName || '').trim().split(' ');
    const firstName = nameParts[0] || 'Buyer';
    const lastName = nameParts.slice(1).join(' ') || 'User';

    dispatch(
      signup({
        email: allData.email,
        password: allData.password,
        firstName,
        lastName,
        publicData: {
          userType: 'customer',
          approvalStatus: 'pending',
          companyName: allData.companyName,
          country: allData.country,
          preferredCurrency: allData.preferredCurrency,
          taxNumber: allData.taxNumber,
          importExportDetails: allData.importExportDetails,
          contactPersonName: allData.contactPersonName,
          phone: allData.phone,
          shippingAddress: {
            street: allData.shippingStreet,
            city: allData.shippingCity,
            state: allData.shippingState,
            postalCode: allData.shippingPostalCode,
            country: allData.shippingCountry,
          },
          billingAddress: {
            street: allData.sameAsShipping ? allData.shippingStreet : allData.billingStreet,
            city: allData.sameAsShipping ? allData.shippingCity : allData.billingCity,
            state: allData.sameAsShipping ? allData.shippingState : allData.billingState,
            postalCode: allData.sameAsShipping ? allData.shippingPostalCode : allData.billingPostalCode,
            country: allData.sameAsShipping ? allData.shippingCountry : allData.billingCountry,
          },
          sameAsShipping: !!allData.sameAsShipping,
        },
      })
    )
      .then(() => history.push('/'))
      .catch(() => {});
  };

  return (
    <div className={css.main}>
      <BuyerSidebar currentStep={currentStep} />
      <div className={css.content}>
        <MobileStepper currentStep={currentStep} />
        {currentStep === 1 && <BuyerStep1Business nextStep={nextStep} initialValues={formData} />}
        {currentStep === 2 && <BuyerStep2Contact nextStep={nextStep} prevStep={prevStep} initialValues={formData} />}
        {currentStep === 3 && <BuyerStep3Address nextStep={nextStep} prevStep={prevStep} initialValues={formData} />}
        {currentStep === 4 && <BuyerStep4Agreement nextStep={nextStep} prevStep={prevStep} initialValues={formData} />}
        {currentStep === 5 && (
          <BuyerStep5Review
            prevStep={prevStep}
            goToStep={goToStep}
            formData={formData}
            onSubmit={handleSubmit}
            submitInProgress={signupInProgress}
            submitError={signupError}
          />
        )}
      </div>
    </div>
  );
};

BuyerRegistration.defaultProps = { className: null, rootClassName: null };
BuyerRegistration.propTypes = { className: PropTypes.string, rootClassName: PropTypes.string };

export default BuyerRegistration;
